import { useEffect, useRef } from "react";
import { warmDepositMergeProver } from "./depositMergeProver";

/** The scope identifies the open form. Only public proving data is prepared;
 * starting a deposit preserves it until the proof acquires the worker. */
export function useDepositMergeWarmup(
  scope: string | null,
  busy: boolean,
  eligible = true,
) {
  const pending = useRef<{ scope: string; release: () => void }>();
  useEffect(() => {
    if (!scope || pending.current?.scope !== scope) {
      pending.current?.release();
      pending.current = undefined;
    }
    if (scope && !busy) {
      pending.current?.release();
      pending.current = eligible
        ? { scope, release: warmDepositMergeProver() }
        : undefined;
    }
  }, [scope, busy, eligible]);
  useEffect(() => () => pending.current?.release(), []);
}
